export default __webpack_public_path__ + "sparkle-icon.png";